// extracted by mini-css-extract-plugin
module.exports = {"label":"Editor_label__iqZJp","editor_wrapper":"Editor_editor_wrapper__7zKTG","editor":"Editor_editor__RtB_9","options":"Editor_options__YcAQF"};